{
  "apiEndpoint": "https://webapp.flease.fr/api",
  "cognitoUserPoolId": "eu-west-1_4HVSkXonG",
  "cognitoUserPoolClientId": "1ekjh0drrehch57ist92h19il5"
}
